const emailBody = ({ document, documentLabel, url, t }) =>
  t("documentControl.view.share.emailBody", {
    documentLabel,
    documentName: document.name,
    url
  });

export default emailBody;
